jQuery.noConflict();
jQuery(document).ready(function(){ 
    if( $('.slidertrio').length > 0 ) {
        $('.slidertrio_elements').owlCarousel({
            dots: true,
            responsive : {
                // breakpoint from 0 up
                0 : {
                    items: 1,
                    loop: false,
                    margin: 15,
                    stagePadding: 30 
                },
                // breakpoint from 480 up
                425 : {
                    loop: true,
                    items: 2,
                    margin: 30,
                },
                // breakpoint from 425 up
                768 : {
                    nav: true,
                    loop: true,
                    margin: 30,
                    items: 3
                }
            }
        })
    }
});
